import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { BLOG_POSTS } from "@/lib/content";

export default function BlogPage() {
    return (
        <div className="page-fade pt-32 md:pt-40 pb-24">
            <Seo
                title="The Aqualyx Journal — Fat Reduction Insights | NZ"
                description="Editorial guides on Aqualyx, double chin contouring, fat dissolving injections and non-surgical body sculpting in New Zealand. Read the latest from Aqualyx Certified Clinics."
                path="/blog"
                breadcrumbs={[
                    { name: "Home", path: "/" },
                    { name: "Journal", path: "/blog" },
                ]}
                schema={{
                    "@context": "https://schema.org",
                    "@type": "Blog",
                    "name": "The Aqualyx Journal",
                    "url": "https://aqualyxnz.co.nz/blog",
                    "publisher": { "@type": "Organization", "name": "Aqualyx New Zealand" },
                    "blogPost": BLOG_POSTS.map((p) => ({
                        "@type": "BlogPosting",
                        "headline": p.title,
                        "url": `https://aqualyxnz.co.nz/blog/${p.slug}`,
                        "datePublished": p.date,
                        "image": p.image,
                        "author": { "@type": "Organization", "name": "Aqualyx New Zealand" }
                    }))
                }}
            />
            <Helmet>
                <meta name="keywords" content="Aqualyx blog NZ, fat dissolving NZ, double chin treatment NZ, jawline contouring NZ, Aqualyx vs Kybella, Aqualyx before after, non surgical body contouring New Zealand" />
            </Helmet>
            <section className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
                    <div className="lg:col-span-8 space-y-6">
                        <div className="eyebrow">The Journal</div>
                        <h1 className="editorial-headline text-6xl md:text-8xl">
                            Editorial<br /><span className="italic text-champagne">readings.</span>
                        </h1>
                    </div>
                    <div className="lg:col-span-4 flex items-end">
                        <p className="text-ink/70 leading-relaxed">
                            Curated reading on Aqualyx, body contouring, and the science of non-surgical fat reduction in New Zealand.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {BLOG_POSTS.map((p, i) => (
                        <Link to={`/blog/${p.slug}`} key={p.slug} data-testid={`blog-list-${i}`} className="group block">
                            <div className="aspect-[4/3] overflow-hidden mb-5">
                                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                            </div>
                            <div className="eyebrow mb-2">{p.category} · {p.read}</div>
                            <h2 className="font-serif text-2xl md:text-3xl leading-tight group-hover:text-champagne transition-colors">{p.title}</h2>
                            <p className="text-sm text-ink/60 mt-2 leading-relaxed">{p.excerpt}</p>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
